import FiltroPropiedades from "./FiltroPropiedades";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";

import {
  getPropiedadesPaginadas,
  postTarjetaProp,
  deleteTarjetaProp,
  publicarEnYapo,
  publicarEnPI,
  actualizarEnPI,
  toggleModoVisitaPI,
  fetchGetAllPlanes,
  fetchAllRegiones,
  getClientesPaginados,
  fetchDeletePropiedad,
  descargarFichaPropiedad,
  setFichaPropiedad,
  eliminarEnPI,
  actualizarEnYapo,
  eliminarEnYapo,
  fetchGetAllUsuarios,
  getUsuariosFiltrados,
  putPropiedadAsignarBroker,
  getLinkPIById,
  getMetricasPI,
  getPIPacks,
  highlightPropiedadPI,
} from "../../action";
import { useEffect, useState, useMemo } from "react";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  styled,
  Switch,
  ListItemSecondaryAction,
  Typography,
  Badge,
  Tooltip,
} from "@mui/material";
import { Close, Error, OpenInNew, RotateLeft, Star, WorkspacePremium } from "@mui/icons-material";
import TourIcon from '@mui/icons-material/Tour';
import FormAgregarPropiedad from "./FormAgregarPropiedad";
import Swal from "sweetalert2";
import { FilaPropiedad } from "./FilaPropiedad";
import QualityTipsModal from "./QualityTipsModal";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import FieldError from "../../utils/FieldError";

const validate = Yup.object().shape({
  idBroker: Yup.string().required("Seleccione un broker"),
});

const isMobile =
  !!navigator.userAgent.match(/iphone|android|blackberry/gi) || false;

const columnsNonMobile = [
  { id: "precio", label: "Precio", minWidth: 40, align: "center" },
  { id: "operacion", label: "Operación", minWidth: "10px", align: "center" },
  { id: "comuna", label: "Comuna", minWidth: 40, align: "center" },
  { id: "codigo", label: "Código", minWidth: 40, align: "center" },
  { id: "tipo", label: "Tipo", minWidth: 70, align: "center" },
  { id: "tipologia", label: "Tipología", minWidth: 50, align: "center" },
  { id: "estado", label: "Estado", minWidth: 140, align: "center" },
  { id: "ficha", label: "Ficha", minWidth: 80, align: "center" },
  { id: "actions", label: "Acciones", minWidth: 120, align: "center" },
];

const columnsMobile = [
  { id: "comuna", label: "Comuna", minWidth: 40, align: "center" },
  { id: "codigo", label: "Código", minWidth: 40, align: "center" },
  { id: "precio", label: "Precio", minWidth: 70, align: "center" },
  { id: "acciones", label: "Acciones", minWidth: 1, align: "center" },
];

const columns = isMobile ? columnsMobile : columnsNonMobile;

const style = {
  position: "absolute",
  top: "0px",
  left: "50%",
  transform: "translate(-50%, 0%)",
  width: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  //maxHeight: '90%'
};

const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#00a62b",
    "&:hover": {
      backgroundColor: "rgba(0, 166, 43, 0.08)",
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#00a62b",
  },
}));

const styleBrokerModal = {
  position: "absolute",
  top: "0px",
  left: "50%",
  transform: "translate(-50%, 0%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  //maxHeight: '90%'
};

const styleMobile = {
  position: "absolute",
  top: "0px",
  left: "0px",
  //transform: "translate(-50%, 0%)",
  width: "100vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  //maxHeight: '90%'
};

const StyledTableHead = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#00a62b",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const getListingTypeLabel = (id) => {
  switch (id) {
    case "gold_premium":
      return "Oro Premium";
    case "gold_pro":
      return "Oro Pro";
    case "gold":
      return "Oro (Destacado)";
    case "silver":
      return "Plata (Normal)";
    case "bronze":
      return "Bronce";
    case "free":
      return "Gratuito";
    default:
      return id ? (id.charAt(0).toUpperCase() + id.slice(1)) : "";
  }
};

const getAvailableHighlightOptions = (packagesInfo) => {
  if (!packagesInfo || !Array.isArray(packagesInfo)) return [];

  const options = [];
  packagesInfo.forEach((pack) => {
    if (pack.status === "active" && pack.package_content === "upgrades" && pack.listing_details) {
      pack.listing_details.forEach((detail) => {
        if (detail.remaining_listings > 0) {
          const existing = options.find((opt) => opt.id === detail.listing_type_id);
          if (existing) {
            existing.remaining += detail.remaining_listings;
            if (!existing.packs.includes(pack.description)) {
              existing.packs.push(pack.description);
            }
          } else {
            options.push({
              id: detail.listing_type_id,
              label: getListingTypeLabel(detail.listing_type_id),
              remaining: detail.remaining_listings,
              packs: [pack.description]
            });
          }
        }
      });
    }
  });
  return options;
};

const getLevelColor = (level) => {
  switch (level?.toLowerCase()) {
    case "professional":
    case "profesional":
      return "#00a62b"; // green
    case "standard":
    case "estándar":
    case "estandar":
      return "#e6c300"; // gold/yellow
    case "basic":
    case "básico":
    case "basico":
      return "#c62828"; // red
    default:
      return "#757575";
  }
};

const getLevelLabel = (level) => {
  switch (level?.toLowerCase()) {
    case "professional":
    case "profesional":
      return "Profesional";
    case "standard":
    case "estándar":
    case "estandar":
      return "Estándar";
    case "basic":
    case "básico":
    case "basico":
      return "Básico";
    default:
      return level || "";
  }
};

const getHealthPercent = (health) => {
  if (health == null) return 0;
  if (health <= 1) return Math.round(health * 100);
  return Math.round(health);
};

const getQualityBadge = (propiedad, onClick) => {
  if (!propiedad || !propiedad.publicadaPortalInmobiliario) {
    return <span>-</span>;
  }
  const level = propiedad.calidadPILevel || "basic";
  const health = propiedad.calidadPIHealth;
  const healthPercent = getHealthPercent(health);
  const color = getLevelColor(level);
  const label = getLevelLabel(level);

  return (
    <Tooltip title={`Calidad PI: ${label} (${healthPercent}%) - Haga clic para ver consejos`}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick(propiedad);
        }}
        size="small"
        sx={{ p: 0.5 }}
      >
        <Badge
          badgeContent={`${healthPercent}%`}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: color,
              color: "#fff",
              fontWeight: "bold",
              fontSize: "8.5px",
              height: "16px",
              minWidth: "24px",
              padding: "0 4px",
            }
          }}
        >
          <WorkspacePremium sx={{ fontSize: 28, color: color }} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

const TablaPropiedades = ({
  idBroker,
  idCliente,
  incluirFiltro,
  incluirBotonCrearPropiedad,
  inluirSelectClientes,
}) => {
  const storageKeyPrefix = "filtroPropiedad1";

  const [openQualityTips, setOpenQualityTips] = useState(false);
  const [selectedPropForQuality, setSelectedPropForQuality] = useState(null);

  const handleOpenQualityTips = (prop) => {
    setSelectedPropForQuality(prop);
    setOpenQualityTips(true);
  };
  const handleCloseQualityTips = () => {
    setOpenQualityTips(false);
    setSelectedPropForQuality(null);
  };

  const dispatch = useDispatch();
  let propiedades = useSelector(
    (state) =>
      state.app.propiedadesPaginadas && state.app.propiedadesPaginadas.results
  );
  let data = useSelector((state) => state.app.propiedadesPaginadas);
  const userData = useSelector((state) => state.app.itemUsuario);

  const isBroker = userData && userData.tipoCuenta === 10;
  const activeColumns = useMemo(() => {
    let cols = isMobile ? [...columnsMobile] : [...columnsNonMobile];
    if (isBroker) {
      if (isMobile) {
        cols.splice(cols.length - 1, 0, { id: "calidadPi", label: "Calidad PI", minWidth: 40, align: "center" });
      } else {
        cols.splice(cols.length - 2, 0, { id: "calidadPi", label: "Calidad PI", minWidth: 80, align: "center" });
      }
    }
    return cols;
  }, [isBroker, isMobile]);
  const [buscador, setBuscador] = useState(localStorage.getItem(`${storageKeyPrefix}Buscador`) ?? "");
  const requestPropiedadesPaginadas = useSelector(
    (state) =>
      state.app.requestPropiedadesPaginadas &&
      state.app.requestPropiedadesPaginadas
  );
  const requestDeleteTarjetaProp = useSelector(
    (state) => state.app.requestDeleteTarjetaProp
  );
  const requestPostTarjetaProp = useSelector(
    (state) => state.app.requestPostTarjetaProp
  );
  const requestUpdatePropiedad = useSelector(
    (state) => state.app.requestUpdatePropiedad
  );
  const requestPropiedadBroker = useSelector(
    (state) => state.app.requestPropiedadBroker
  );
  const requestUsuarioFiltrados = useSelector(
    (state) => state.app.requestUsuarioFiltrados
  );
  const brokers = useSelector((state) => state.app.usuariosFiltrados);
  const errorMessage = useSelector((state) => state.app.errorMessage);
  const planes = useSelector((state) => state.app.itemPlanes);
  const [isLoading, setIsLoading] = useState(false);
  const [currentProp, setCurrentProp] = useState(null);
  const [dateFromPI, setDateFromPI] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().slice(0, 10);
  });
  const [dateToPI, setDateToPI] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().slice(0, 10);
  });
  const [metricsPI, setMetricsPI] = useState({
    vistas: 0,
    contactosTotales: 0,
    clickWsp: 0,
    clickTelefono: 0,
  });
  const [loadingMetricsPI, setLoadingMetricsPI] = useState(false);
  const [copyNotification, setCopyNotification] = useState(false);
  const [packagesInfo, setPackagesInfo] = useState(null);
  const [loadingPacks, setLoadingPacks] = useState(false);

  const handleCloseCopyNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setCopyNotification(false);
  };
  const fichaPropiedad = useSelector((state) => state.app.fichaPropiedad);
  const requestPostPI = useSelector((state) => state.app.requestPostPI);
  const requestPutPI = useSelector((state) => state.app.requestPutPI);
  const requestHighlightPI = useSelector((state) => state.app.requestHighlightPI);
  const requestDeletePI = useSelector((state) => state.app.requestDeletePI);
  const requestPostYapo = useSelector((state) => state.app.requestPostYapo);
  const requestPutYapo = useSelector((state) => state.app.requestPutYapo);
  const requestDeleteYapo = useSelector((state) => state.app.requestDeleteYapo);
  const requestDeletePropiedad = useSelector(
    (state) => state.app.requestDeletePropiedad
  );

  useEffect(() => {
    if (
      requestPropiedadesPaginadas === "LOADING" ||
      requestDeletePropiedad === "LOADING" ||
      requestPostTarjetaProp === "LOADING" ||
      requestDeleteTarjetaProp === "LOADING" ||
      requestPostPI === "LOADING" ||
      requestPutPI === "LOADING" ||
      requestDeletePI === "LOADING" ||
      requestHighlightPI === "LOADING" ||
      requestPostYapo === "LOADING" ||
      requestPutYapo === "LOADING" ||
      requestDeleteYapo === "LOADING"
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    requestPropiedadesPaginadas,
    requestDeletePropiedad,
    requestDeleteTarjetaProp,
    requestPostTarjetaProp,
    requestPostYapo,
    requestPutYapo,
    requestDeleteYapo,
    requestPostPI,
    requestPutPI,
    requestDeletePI,
    requestHighlightPI,
  ]);

  useEffect(() => {
    dispatch(fetchGetAllPlanes());
    dispatch(fetchAllRegiones());
    //dispatch(fetchGetAllClientes());
    dispatch(getUsuariosFiltrados(10));
    dispatch(fetchGetAllUsuarios());
    dispatch(getClientesPaginados(0, 999, "true"));
  }, []);
  const [filtroValues, setFiltroValues] = useState({
    tipoOperacion: localStorage.getItem(`${storageKeyPrefix}tipoOperacion`) ?? "",
    tipoPropiedad: localStorage.getItem(`${storageKeyPrefix}tipoPropiedad`) ?? "",
    comuna: localStorage.getItem(`${storageKeyPrefix}comuna`) ?? "",
    dormitoriosDesde: localStorage.getItem(`${storageKeyPrefix}DormitoriosDesde`) ?? 0,
    dormitoriosHasta: localStorage.getItem(`${storageKeyPrefix}DormitoriosHasta`) ?? 0,
    baniosDesde: localStorage.getItem(`${storageKeyPrefix}BaniosDesde`) ?? 0,
    baniosHasta: localStorage.getItem(`${storageKeyPrefix}BaniosHasta`) ?? 0,
    codigoPropiedad: localStorage.getItem(`${storageKeyPrefix}codigoPropiedad`) ?? "",
    superficieTotalDesde: localStorage.getItem(`${storageKeyPrefix}SuperficieTotalDesde`) ?? 0,
    superficieTotalHasta: localStorage.getItem(`${storageKeyPrefix}SuperficieTotalHasta`) ?? 0,
    superficieUtilDesde: localStorage.getItem(`${storageKeyPrefix}SuperficieUtilDesde`) ?? 0,
    superficieUtilHasta: localStorage.getItem(`${storageKeyPrefix}SuperficieUtilHasta`) ?? 0,
    estadoPropiedad: localStorage.getItem(`${storageKeyPrefix}Estado`) ?? "",
    tipoMoneda: localStorage.getItem(`${storageKeyPrefix}TipoMoneda`) ?? "",
    estacionamiento: localStorage.getItem(`${storageKeyPrefix}Estacionamientos`) ?? 0,
    bodega: localStorage.getItem(`${storageKeyPrefix}Bodegas`) ?? 0,
    idBroker: userData && userData.tipoCuenta === 10 ? userData.userId : localStorage.getItem(`${storageKeyPrefix}idBroker`) ?? "",
    valorDesde: localStorage.getItem(`${storageKeyPrefix}valorDesde`) ?? 0,
    valorHasta: localStorage.getItem(`${storageKeyPrefix}valorHasta`) ?? 0,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("createdAtDescending");

  const [openDialogYapo, setOpenDialogYapo] = useState(false);
  const handleDialogYapoOpen = (prop) => {
    setCurrentProp(prop);
    setOpenDialogYapo(true);
  };
  const handleCloseDialogYapo = () => setOpenDialogYapo(false);

  const [openDialogPI, setOpenDialogPI] = useState(false);
  const handleDialogPIOpen = (prop) => {

    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const to = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      .toISOString()
      .slice(0, 10);
    setDateFromPI(from);
    setDateToPI(to);
    setCurrentProp(prop);
    setOpenDialogPI(true);
  };
  const handleCloseDialogPI = () => setOpenDialogPI(false);

  const [openEditModal, setOpenEditModal] = useState(false);
  const handleOpenEditModal = (prop) => {
    setCurrentProp(prop);
    setOpenEditModal(true);
  };

  const handleCloseEditModal = (e, reason) => {
    setOpenEditModal(false);
  };

  const [openBrokerModal, setOpenBrokerModal] = useState(false);
  const handleOpenBrokerModal = (prop) => {
    setCurrentProp(prop);
    setOpenBrokerModal(true);
  };
  const handleCloseBrokerModal = (e, reason) => {
    setOpenBrokerModal(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onChangeSortBy = (event) => {
    setSortBy(event.target.value);
  };

  const openLinkPI = async (idPublicacion) => {
    try {
      // console.log(idPublicacion);
      const link = await dispatch(getLinkPIById(idPublicacion));
      // const link = `https://www.portalinmobiliario.com/${idPublicacion.substring(
      //   0,
      //   3
      // )}-${idPublicacion.substring(3)}`;
      window.open(link, "_blank");
    } catch (error) {
      console.error("Error al obtener el link de Portal Inmobiliario", error);
    };
  };
  const openPermaLinkPI = (permalink) => {
    window.open(permalink, "_blank");
  };

  const publicarEnPortalPI = (propiedadSeleccionada) => {
    let cuentaConCtdadMinimaFotos = !(
      propiedadSeleccionada.imagenes === null ||
      (Array.isArray(propiedadSeleccionada.imagenes) &&
        propiedadSeleccionada.imagenes.length < 12)
    );
    const msgWarning = `<p class="red"><strong>Nota:</strong> la propiedad no cuenta con el mínimo de 12 fotos para estar bien posicionada en Portal Inmobiliario</p>`;
    Swal.fire({
      title: `Publicar en Portal Inmobiliario`,
      html: `<p>¿Está seguro de publicar esta propiedad en Portal Inmobiliario?</p> ${!cuentaConCtdadMinimaFotos ? msgWarning : ""
        }`,
      //text: `¿Está seguro de publicar esta propiedad en Portal Inmobiliario?`,
      showCancelButton: true,
      confirmButtonText: "Publicar",
      cancelButtonText: `Cancelar`,
    }).then((result) => {
      if (result.value) {
        handleCloseDialogPI();
        dispatch(publicarEnPI(propiedadSeleccionada.id));
      }
    });
  };

  const publicarEnPortalYapo = (propiedadSeleccionada) => {
    Swal.fire({
      title: `Publicar en Yapo`,
      text: `¿Está seguro de publicar esta propiedad en Yapo?`,
      showCancelButton: true,
      confirmButtonText: "Publicar",
      cancelButtonText: `Cancelar`,
    }).then((result) => {
      if (result.value) {
        dispatch(publicarEnYapo(propiedadSeleccionada.id));
      }
    });
  };

  const actualizarEnPortalInmobiliario = (propiedadSeleccionada) => {
    Swal.fire({
      title: `Actualizar publicación en Portal Inmobiliario`,
      html: `<p>¿Está seguro de actualizar la publicación de esta propiedad en Portal Inmobiliario?</p><p> <strong>Nota:</strong> Ten en consideración que los campos que puedes actualizar son:</p>
      <p>
      Ubicación (dirección, comuna y/o ciudad)
      <br />Precio
      <br />Dormitorios
      <br />Baños
      <br />Estacionamientos
      <br />Bodegas
      <br />Superficie util
      <br />Superficie total
      </p>`,
      showCancelButton: true,
      confirmButtonText: "Publicar",
      cancelButtonText: `Cancelar`,
    }).then((result) => {
      if (result.value) {
        handleCloseDialogPI();
        dispatch(actualizarEnPI(propiedadSeleccionada.id));
      }
    });
  };
  const toggleModoVisita = (propiedadSeleccionada) => {
    dispatch(toggleModoVisitaPI(propiedadSeleccionada.id));
  }

  const actualizarYapo = (propiedadSeleccionada) => {
    Swal.fire({
      title: `Actualizar publicación en Yapo`,
      text: `¿Está seguro de actualizar la publicación de esta propiedad en Yapo?`,
      showCancelButton: true,
      confirmButtonText: "Actualizar",
      cancelButtonText: `Cancelar`,
    }).then((result) => {
      if (result.value) {
        handleCloseDialogYapo();
        dispatch(actualizarEnYapo(propiedadSeleccionada.id));
      }
    });
  };
  const eliminarYapo = (propiedadSeleccionada) => {
    Swal.fire({
      title: `Eliminar publicación en Yapo`,
      text: `¿Está seguro de eliminar la publicación de esta propiedad en Yapo?`,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: `Cancelar`,
    }).then((result) => {
      if (result.value) {
        handleCloseDialogYapo();
        dispatch(eliminarEnYapo(propiedadSeleccionada.id));
      }
    });
  };

  const eliminarEnPortalInmobiliario = (propiedadSeleccionada) => {
    Swal.fire({
      title: `Eliminar publicación en Portal Inmobiliario`,
      text: `¿Está seguro de eliminar la publicación de esta propiedad en Portal Inmobiliario?`,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: `Cancelar`,
    }).then((result) => {
      if (result.value) {
        handleCloseDialogPI();
        dispatch(eliminarEnPI(propiedadSeleccionada.id));
      }
    });
  };

  const fetchMetricsPI = async (propId, from, to) => {
    if (!propId) return;
    setLoadingMetricsPI(true);
    try {
      const inicio = `${from}T00:00:00`;
      const fin = `${to}T23:59:59`;
      const data = await dispatch(getMetricasPI(inicio, fin, propId));
      if (data) {
        setMetricsPI({
          vistas: data?.value?.data?.visitas['0']?.total_visits ?? -1,
          contactosTotales: data?.value?.data?.preguntas?.total ?? -1,
          clickTelefono: data?.value?.data?.clicksTelefono?.total ?? -1,
          clickWsp: data?.value?.data?.clicksWhatsapp?.total ?? -1,
        });
      } else {
        setMetricsPI({ vistas: -1, contactosTotales: -1, clickWsp: -1, clickTelefono: -1 });
      }
    } catch (e) {
      setMetricsPI({ vistas: -1, contactosTotales: -1, clickWsp: -1, clickTelefono: -1 });
    } finally {
      setLoadingMetricsPI(false);
    }
  };

  useEffect(() => {
    if (openDialogPI && currentProp && dateFromPI && dateToPI) {
      fetchMetricsPI(currentProp.idPublicacionPI, dateFromPI, dateToPI);
    }
  }, [openDialogPI, currentProp, dateFromPI, dateToPI]);

  useEffect(() => {
    if (openDialogPI && currentProp) {
      setLoadingPacks(true);
      dispatch(getPIPacks("ALL", "active"))
        .then((data) => {
          if (data) {
            setPackagesInfo(data);
          }
        })
        .catch((err) => {
          console.error("Error fetching packages info", err);
        })
        .finally(() => {
          setLoadingPacks(false);
        });
    } else {
      setPackagesInfo(null);
    }
  }, [openDialogPI, currentProp]);

  useEffect(() => {
    if (openDialogPI && currentProp && propiedades) {
      const updatedProp = propiedades.find((p) => p.id === currentProp.id);
      if (updatedProp) {
        if (
          updatedProp.destacadaPortalInmobiliario !== currentProp.destacadaPortalInmobiliario ||
          updatedProp.publicadaPortalInmobiliario !== currentProp.publicadaPortalInmobiliario ||
          updatedProp.idPublicacionPI !== currentProp.idPublicacionPI
        ) {
          setCurrentProp(updatedProp);
        }
      }
    }
  }, [propiedades, openDialogPI]);

  const applyThisMonth = () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const to = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      .toISOString()
      .slice(0, 10);
    setDateFromPI(from);
    setDateToPI(to);
  };

  const applyLastMonth = () => {
    const now = new Date();
    const last = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const from = new Date(last.getFullYear(), last.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const to = new Date(last.getFullYear(), last.getMonth() + 1, 0)
      .toISOString()
      .slice(0, 10);
    setDateFromPI(from);
    setDateToPI(to);
  };

  if (requestPostYapo === "ERROR") {
    Swal.fire("Error", errorMessage, "error");
  }
  if (requestPostYapo === "SUCCESS") {
    Swal.fire({
      title: "Publicado en Yapo",
      text: "Se ha publicado la propiedad en Yapo exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestPutYapo === "SUCCESS") {
    Swal.fire({
      title: "Actualizado en Yapo",
      text: "Se ha actualizado la propiedad en Yapo exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestDeleteYapo === "SUCCESS") {
    Swal.fire({
      title: "Eliminado en Yapo",
      text: "Se ha eliminado la propiedad en Yapo exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestPostPI === "ERROR") {
    Swal.fire("Error", errorMessage, "error");
  }

  if (requestPostPI === "SUCCESS") {
    Swal.fire({
      title: "Publicado en Portal Inmobiliario",
      text: "Se ha publicado la propiedad en Portal Inmobiliario exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestPutPI === "SUCCESS") {
    Swal.fire({
      title: "Actualizado en Portal Inmobiliario",
      text: "Se ha actualizado la propiedad en Portal Inmobiliario exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestHighlightPI === "SUCCESS") {
    Swal.fire({
      title: "Destaque actualizado",
      text: "Se ha actualizado el destaque de la propiedad exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestDeletePI === "SUCCESS") {
    Swal.fire({
      title: "Eliminado en Portal Inmobiliario",
      text: "Se ha eliminado la propiedad en Portal Inmobiliario exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestPropiedadBroker == "SUCCESS") {
    Swal.fire({
      title: "Broker actualizado",
      text: "Se ha actualizado el broker asociado a la propiedad exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        handleCloseBrokerModal();
        reloadPropiedades();
      }
    });
  }

  useEffect(() => {
    dispatch(
      getPropiedadesPaginadas(
        filtroValues.estadoPropiedad,
        filtroValues.idBroker,
        page + 1,
        rowsPerPage,
        "todos",
        sortBy,
        filtroValues.comuna,
        filtroValues.tipoPropiedad,
        filtroValues.tipoOperacion,
        filtroValues.valorDesde,
        filtroValues.valorHasta,
        filtroValues.baniosDesde,
        filtroValues.baniosHasta,
        filtroValues.dormitoriosDesde,
        filtroValues.dormitoriosHasta,
        filtroValues.superficieUtilDesde,
        filtroValues.superficieUtilHasta,
        filtroValues.superficieTotalDesde,
        filtroValues.superficieTotalHasta,
        filtroValues.codigoPropiedad,
        filtroValues.tipoMoneda,
        idCliente,
        buscador,
        filtroValues.estacionamiento,
        filtroValues.bodega
      )
    );
  }, [page, rowsPerPage, sortBy, idCliente, buscador]);

  const sortOptions = {
    createdAtDescending: "Ordenar por fecha de creación descendiente",
    createdAtAscending: "Ordenar por fecha de creación ascendiente",
    precioAscending: "Ordenar por precio ascendiente",
    precioDescending: "Ordenar por precio descendiente",
  };

  const onCopyLink = (propiedad) => {
    setCopyNotification(true);
    let baseUrl =
      window.location.hostname.includes("dev.propins.cl") ||
        window.location.hostname.includes("localhost")
        ? "https://dev.propins.cl/info-propiedad?idprop="
        : "https://propins.cl/info-propiedad?idprop=";

    navigator.clipboard.writeText(`${baseUrl}${propiedad.id}`);
  };

  const showConfirmationDialog = (row, isDelete) => {
    let verb = "Generar";
    if (isDelete) {
      verb = "Deshabilitar";
    }
    Swal.fire({
      title: `${verb} tarjeta propiedad`,
      text: `Confirma que desea ${verb.toLowerCase()} la tarjeta para esta propiedad`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirmar",
    }).then((result) => {
      if (result.value) {
        if (isDelete) {
          dispatch(deleteTarjetaProp(row.id));
        } else {
          dispatch(postTarjetaProp(row.id));
        }
      }
    });
  };

  const showDeleteConfirmationDialog = (id) => {
    Swal.fire({
      title: `Eliminar la propiedad`,
      text: `Confirma que desea eliminar esta propiedad`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirmar",
    }).then((result) => {
      if (result.value) {
        dispatch(fetchDeletePropiedad(id));
      }
    });
  };

  if (requestPostTarjetaProp === "SUCCESS") {
    Swal.fire({
      title: "Tarjeta propiedad generada",
      text: "Se ha generado la tarjeta para la propiedad seleccionada",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestDeletePropiedad === "SUCCESS") {
    Swal.fire({
      title: "Propiedad eliminada",
      text: "Se ha eliminado la propiedad exitosamente",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (requestDeleteTarjetaProp === "SUCCESS") {
    Swal.fire({
      title: "Tarjeta propiedad deshabilitada",
      text: "Se ha deshabilitado la tarjeta para la propiedad seleccionada",
      icon: "success",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  if (
    requestDeleteTarjetaProp === "ERROR" ||
    requestPostTarjetaProp === "ERROR" ||
    requestPropiedadBroker === "ERROR" ||
    requestHighlightPI === "ERROR"
  ) {
    Swal.fire({
      title: "Error",
      text: errorMessage,
      icon: "error",
    }).then((result) => {
      if (result.value || result.dismiss === "backdrop") {
        reloadPropiedades();
      }
    });
  }

  const reloadPropiedades = () => {
    dispatch(
      getPropiedadesPaginadas(
        filtroValues.estadoPropiedad,
        filtroValues.idBroker,
        page + 1,
        rowsPerPage,
        "todos",
        sortBy,
        filtroValues.comuna,
        filtroValues.tipoPropiedad,
        filtroValues.tipoOperacion,
        filtroValues.valorDesde,
        filtroValues.valorHasta,
        filtroValues.baniosDesde,
        filtroValues.baniosHasta,
        filtroValues.dormitoriosDesde,
        filtroValues.dormitoriosHasta,
        filtroValues.superficieUtilDesde,
        filtroValues.superficieUtilHasta,
        filtroValues.superficieTotalDesde,
        filtroValues.superficieTotalHasta,
        filtroValues.codigoPropiedad,
        filtroValues.tipoMoneda,
        idCliente,
        buscador,
        filtroValues.estacionamiento,
        filtroValues.bodega
      )
    );
  };

  const onChangeBuscador = (e) => {
    const nuevoValor = e.target.value;
    localStorage.setItem(`${storageKeyPrefix}Buscador`, nuevoValor);
    setBuscador(nuevoValor);
    setPage(0);
  };

  const descargarFicha = (id) => {
    dispatch(descargarFichaPropiedad(id));
  };

  const submitBroker = (formValues) => {
    if (currentProp) {
      dispatch(putPropiedadAsignarBroker(currentProp.id, formValues.idBroker));
    }
  };

  useEffect(() => {
    if (fichaPropiedad !== null && fichaPropiedad !== undefined) {
      const url = window.URL.createObjectURL(new Blob([fichaPropiedad]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Ficha propiedad.pdf`);
      document.body.appendChild(link);
      link.click();
      dispatch(setFichaPropiedad(null));
    }
  }, [fichaPropiedad]);

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        {incluirFiltro && (
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FiltroPropiedades
                page={page}
                rowsPerPage={rowsPerPage}
                sortBy={sortBy}
                getPropiedades={getPropiedadesPaginadas}
                filtroValues={filtroValues}
                setFiltroValues={setFiltroValues}
                buscador={buscador}
                storageKeyPrefix={storageKeyPrefix}
                setPage={setPage}
                setBuscador={setBuscador}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          sx={{ mt: 2 }}
          container
          justifyContent={
            incluirBotonCrearPropiedad ? "space-between" : "flex-end"
          }
        >
          {incluirBotonCrearPropiedad && (
            <Grid item className="alignLeft">
              <button
                className="boton"
                onClick={() => handleOpenEditModal(null)}
              >
                Agregar propiedad
              </button>
            </Grid>
          )}
          <Grid item>
            <Grid container justifyContent={"space-between"}>
              <Grid item>
                <select
                  value={sortBy}
                  onChange={onChangeSortBy}
                  className="seleccionador"
                  placeholder="Ordenar por..."
                >
                  {Object.keys(sortOptions).map((s) => (
                    <option value={s}>{sortOptions[s]}</option>
                  ))}
                </select>
              </Grid>
              <Grid item>
                <input
                  type="text"
                  placeholder="Buscar"
                  className="buscar"
                  value={buscador}
                  onChange={onChangeBuscador}
                />
                <SearchIcon />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isLoading && <CircularProgress />}
        {requestPropiedadesPaginadas === "ERROR" && (
          <Grid
            container
            sx={{ mt: 2 }}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              <Paper variant="outlined">
                <Error sx={{ fontSize: 40 }} />
                Ha habido un error
              </Paper>
            </Grid>
          </Grid>
        )}
        {requestPropiedadesPaginadas === "IDLE" &&
          !Swal.isVisible() &&
          !isLoading &&
          propiedades && (
            <Paper component={Paper} style={{ marginBottom: "2rem" }}>
              <TableContainer>
                <Table size={isMobile ? "small" : "medium"}>
                  <TableHead>
                    <TableRow>
                      {activeColumns.map((column) => (
                        <StyledTableHead
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </StyledTableHead>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {propiedades.length === 0 ? (
                      <div>
                        No se han encontrado resultados para su búsqueda
                      </div>
                    ) : (
                      propiedades.map((propiedad, i) => (
                        <FilaPropiedad
                          propiedad={propiedad}
                          i={i}
                          isMobile={isMobile}
                          showConfirmationDialog={showConfirmationDialog}
                          descargarFicha={descargarFicha}
                          showDeleteConfirmationDialog={
                            showDeleteConfirmationDialog
                          }
                          handleOpenEditModal={handleOpenEditModal}
                          onCopyLink={onCopyLink}
                          handleDialogYapoOpen={handleDialogYapoOpen}
                          publicarEnPortalYapo={publicarEnPortalYapo}
                          handleDialogPIOpen={handleDialogPIOpen}
                          publicarEnPortalPI={publicarEnPortalPI}
                          handleOpenBrokerModal={handleOpenBrokerModal}
                          handleOpenQualityTips={handleOpenQualityTips}
                        />
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {requestPropiedadesPaginadas === "IDLE" &&
                propiedades &&
                propiedades.length > 0 && (
                  <TablePagination
                    component="div"
                    count={data && data.totalResults}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    SelectProps={{
                      inputProps: { "aria-label": "Cantidad" },
                      native: true,
                    }}
                    labelRowsPerPage={""}
                  />
                )}
            </Paper>
          )}

        <Modal
          disableScrollLock={false}
          open={openEditModal}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            overflowY: "auto",
            top: isMobile ? "0px" : "10px",
            maxHeight: isMobile ? "100%" : "95%",
          }}
        >
          <Box sx={isMobile ? styleMobile : style}>
            <Grid
              container
              justifyContent="space-between"
              alignItems={"center"}
              sx={{ marginBottom: 2 }}
            >
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                <h3 className="alignLeft">
                  {currentProp ? "Editar propiedad" : "Agregar propiedad"}
                </h3>
              </Grid>
              <Grid item>
                <IconButton
                  color="primary"
                  aria-label="copiar"
                  component="span"
                  onClick={() => handleCloseEditModal()}
                >
                  <Close sx={{ fontSize: "20pt" }} />
                </IconButton>
              </Grid>
            </Grid>
            <FormAgregarPropiedad
              initialValues={currentProp}
              planes={planes}
              idCliente={idCliente}
              submitMethod={null}
              requestState={requestUpdatePropiedad}
              reloadMethod={reloadPropiedades}
              handleClose={handleCloseEditModal}
              inluirSelectClientes={inluirSelectClientes}
            />
          </Box>
        </Modal>
        <Modal
          disableScrollLock={false}
          open={openBrokerModal}
          onClose={handleCloseBrokerModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            overflowY: "auto",
            top: isMobile ? "0px" : "10px",
            maxHeight: isMobile ? "100%" : "95%",
          }}
        >
          <Box sx={isMobile ? styleMobile : styleBrokerModal}>
            {requestPropiedadBroker == "LOADING" && (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={true}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
            <Grid
              container
              justifyContent="space-between"
              alignItems={"center"}
              sx={{ marginBottom: 2 }}
            >
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                <h3 className="alignLeft">Administrar broker propiedad</h3>
              </Grid>
              <Grid item>
                <IconButton
                  color="primary"
                  aria-label="copiar"
                  component="span"
                  onClick={() => handleCloseBrokerModal()}
                >
                  <Close sx={{ fontSize: "20pt" }} />
                </IconButton>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-start">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="alignLeft"
              >
                Propiedad: {currentProp && currentProp.codigoPropiedad}
              </Grid>
            </Grid>
            <Formik
              initialValues={{
                idBroker: currentProp && currentProp.idBroker,
              }}
              validationSchema={validate}
              onSubmit={submitBroker}
            >
              {({ handleSubmit }) => (
                <>
                  <Form onSubmit={handleSubmit} className="form-container">
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <label className="milabel">Broker</label>
                        <Field
                          name="idBroker"
                          as="select"
                          className="miSelect"
                        //disabled={idCliente ? true : false}
                        >
                          <option value={""}>- Seleccione -</option>
                          {brokers &&
                            brokers.length > 0 &&
                            brokers.map((c) => (
                              <option value={c.id}>
                                {c.nombres} {c.apellidos}
                              </option>
                            ))}
                        </Field>
                        <FieldError name="idBroker" />
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
                      <Grid item>
                        <Button
                          onClick={handleCloseBrokerModal}
                          className="main-btn"
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          type="submit"
                          className="main-btn"
                          variant="contained"
                          color="success"
                        >
                          Guardar
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                </>
              )}
            </Formik>
          </Box>
        </Modal>

        <Dialog
          onClose={handleCloseDialogYapo}
          aria-labelledby="simple-dialog-title"
          open={openDialogYapo}
        >
          <DialogTitle id="simple-dialog-title">
            Administrar publicación en Yapo
          </DialogTitle>
          <List>
            <ListItem autoFocus button>
              <ListItemIcon>
                <OpenInNew />
              </ListItemIcon>
              <ListItemText
                primary="Ir a la publicación"
                onClick={() =>
                  window.open(`${currentProp.urlPublicacionYapo}`, "_blank")
                }
              />
            </ListItem>

            <ListItem autoFocus button>
              <ListItemIcon>
                <RotateLeft />
              </ListItemIcon>
              <ListItemText
                primary="Actualizar publicación en Yapo"
                secondary="En caso de que hayas actualizado los datos de la propiedad"
                onClick={() => actualizarYapo(currentProp)}
              />
            </ListItem>
            <ListItem autoFocus button>
              <ListItemIcon>
                <Close />
              </ListItemIcon>
              <ListItemText
                primary="Eliminar publicación en Yapo"
                secondary="Dar de baja la publicación"
                onClick={() => eliminarYapo(currentProp)}
              />
            </ListItem>
          </List>
        </Dialog>

        <Dialog
          onClose={handleCloseDialogPI}
          aria-labelledby="simple-dialog-title"
          open={openDialogPI}
        >
          <DialogTitle id="simple-dialog-title">
            Administrar publicación en Portal Inmobiliario
          </DialogTitle>
          <List>
            <ListItem autoFocus button>
              <ListItemIcon>
                <RotateLeft />
              </ListItemIcon>
              <ListItemText
                primary="Actualizar publicación en Portal Inmobiliario"
                secondary="En caso de que hayas actualizado los datos de la propiedad"
                onClick={() => actualizarEnPortalInmobiliario(currentProp)}
              />
            </ListItem>

            <ListItem autoFocus button>
              <ListItemIcon>
                <TourIcon />
              </ListItemIcon>
              <ListItemText
                primary="Activar botón de visita"
                onClick={() => toggleModoVisita(currentProp)}
              />
            </ListItem>

            <ListItem autoFocus button>
              <ListItemIcon>
                <OpenInNew />
              </ListItemIcon>

              <ListItemText
                primary="Ir a la publicación"
                onClick={() => {
                  if (currentProp.permaLinkPI) {
                    openPermaLinkPI(currentProp.permaLinkPI);
                  } else {
                    openLinkPI(currentProp.idPublicacionPI);
                  }
                }}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Star style={{ color: currentProp && currentProp.destacadaPortalInmobiliario ? "#e6c300" : "#777" }} />
              </ListItemIcon>
              <ListItemText
                primary="Destacar propiedad en Portal Inmobiliario"
                secondary="Destaca esta propiedad consumiendo cupos de tu paquete"
              />
              <ListItemSecondaryAction>
                <GreenSwitch
                  edge="end"
                  checked={currentProp && currentProp.destacadaPortalInmobiliario ? true : false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    if (checked) {
                      const options = getAvailableHighlightOptions(packagesInfo);
                      if (options.length > 1) {
                        Swal.fire({
                          title: "Selecciona el tipo de destaque",
                          text: "Tienes múltiples opciones de destaque con cupo disponible:",
                          input: "radio",
                          inputOptions: options.reduce((acc, opt) => {
                            acc[opt.id] = `${opt.label} (${opt.remaining} cupos libres en ${opt.packs.join(", ")})`;
                            return acc;
                          }, {}),
                          inputValue: options[0].id,
                          showCancelButton: true,
                          confirmButtonText: "Destacar",
                          cancelButtonText: "Cancelar",
                          inputValidator: (value) => {
                            if (!value) {
                              return "¡Debes seleccionar una opción!";
                            }
                          }
                        }).then((result) => {
                          if (result.value) {
                            dispatch(highlightPropiedadPI(currentProp.id, true, result.value));
                          }
                        });
                      } else if (options.length === 1) {
                        const selectedOpt = options[0];
                        Swal.fire({
                          title: `Destacar propiedad`,
                          text: `Se destacará la propiedad automáticamente usando "${selectedOpt.label}" (quedan ${selectedOpt.remaining} cupos).`,
                          icon: "info",
                          showCancelButton: true,
                          confirmButtonText: "Confirmar",
                          cancelButtonText: "Cancelar"
                        }).then((result) => {
                          if (result.value) {
                            dispatch(highlightPropiedadPI(currentProp.id, true, selectedOpt.id));
                          }
                        });
                      } else {
                        Swal.fire({
                          title: "Sin cupos de destaque",
                          text: "No se detectaron paquetes de destaque con cupos disponibles.",
                          icon: "error",
                          confirmButtonText: "Aceptar"
                        });
                      }
                    } else {
                      Swal.fire({
                        title: "¿Quitar destaque?",
                        text: "La propiedad volverá a ser una publicación estándar (Plata).",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Quitar destaque",
                        cancelButtonText: "Cancelar"
                      }).then((result) => {
                        if (result.value) {
                          dispatch(highlightPropiedadPI(currentProp.id, false));
                        }
                      });
                    }
                  }}
                  disabled={!currentProp || !currentProp.publicadaPortalInmobiliario}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem autoFocus button>
              <ListItemIcon>
                <Close />
              </ListItemIcon>
              <ListItemText
                primary="Eliminar publicación en Portal Inmobiliario"
                secondary="Dar de baja la publicación"
                onClick={() => eliminarEnPortalInmobiliario(currentProp)}
              />
            </ListItem>
          </List>

          <Box sx={{ p: 2, borderTop: "1px solid #eee", minWidth: 480 }}>
            <Grid container rowSpacing={2} alignItems="center">
              <Grid container spacing={2} alignItems="end">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <Box>
                      <strong>Métricas</strong>
                      <div style={{ fontSize: 12, color: "#666" }}>
                        Seleccione rango de fechas para ver métricas de la
                        publicación
                      </div>
                    </Box>
                    {currentProp && currentProp.publicadaPortalInmobiliario && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography variant="caption" sx={{ color: "#666", fontWeight: "bold" }}>
                          Calidad PI:
                        </Typography>
                        {getQualityBadge(currentProp, handleOpenQualityTips)}
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <label className="milabel">Desde</label>
                  <input
                    type="date"
                    value={dateFromPI}
                    onChange={(e) => setDateFromPI(e.target.value)}
                    className="miInput"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <label className="milabel">Hasta</label>
                  <input
                    type="date"
                    value={dateToPI}
                    onChange={(e) => setDateToPI(e.target.value)}
                    className="miInput"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "end",
                      height: "100%",
                    }}
                  >
                    <button
                      className="boton small"
                      onClick={applyThisMonth}
                      style={{ width: "100%", height: "25.6px", padding: "0px" }}
                    >
                      Este mes
                    </button>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "end",
                      height: "100%",
                    }}
                  >
                    <button
                      className="boton small"
                      onClick={applyLastMonth}
                      style={{ width: "100%", height: "25.6px", padding: "0px" }}
                    >
                      Mes anterior
                    </button>
                  </div>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {loadingMetricsPI ? (
                  <CircularProgress size={20} />
                ) : (
                  <Grid
                    container
                    wrap="nowrap"
                    spacing={2}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    className="metricasPI"
                  >
                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                      <div className="metrica" style={{ textAlign: "center" }}>
                        <div className="metrica-title">Vistas</div>
                        <div className="metrica-value">{metricsPI.vistas}</div>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                      <div className="metrica" style={{ textAlign: "center" }}>
                        <div className="metrica-title">Contactos</div>
                        <div className="metrica-value">
                          {metricsPI.contactosTotales}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                      <div className="metrica" style={{ textAlign: "center" }}>
                        <div className="metrica-title">Llamadas</div>
                        <div className="metrica-value">
                          {metricsPI.clickTelefono}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                      <div className="metrica" style={{ textAlign: "center" }}>
                        <div className="metrica-title">WhatsApp</div>
                        <div className="metrica-value">
                          {metricsPI.clickWsp}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ p: 3, borderTop: "1px solid #eee", backgroundColor: "#fafafa", minWidth: 480 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2, color: "#333" }}>
              Estado de tus paquetes contratados:
            </Typography>
            {loadingPacks ? (
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <CircularProgress size={20} />
                <span style={{ marginLeft: 10, fontSize: 13, color: "#666" }}>
                  Consultando cupos en Portal Inmobiliario...
                </span>
              </Box>
            ) : packagesInfo && Array.isArray(packagesInfo) && packagesInfo.length > 0 ? (
              <Box>
                {/* Group packages by content type */}
                {["publications", "upgrades", "developments"].map((contentGroup) => {
                  const filteredPacks = packagesInfo.filter(
                    (pack) => pack.package_content === contentGroup
                  );

                  if (filteredPacks.length === 0) return null;

                  const groupTitle =
                    contentGroup === "publications"
                      ? "Publicaciones Estándar"
                      : contentGroup === "upgrades"
                        ? "Destaques / Upgrades"
                        : "Emprendimientos / Proyectos";

                  return (
                    <Box key={contentGroup} sx={{ mb: 3 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                          letterSpacing: 1,
                          color: "#888",
                          display: "block",
                          mb: 1,
                          borderBottom: "1px solid #e0e0e0",
                          pb: 0.5,
                        }}
                      >
                        {groupTitle}
                      </Typography>
                      <List dense disablePadding>
                        {filteredPacks.map((pack) => {
                          const dateExpiresStr = pack.date_expires
                            ? new Date(pack.date_expires).toLocaleDateString("es-CL", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            })
                            : null;

                          return (
                            <Box
                              key={pack.id}
                              sx={{
                                mb: 1.5,
                                p: 1.5,
                                backgroundColor: "#fff",
                                borderRadius: 1,
                                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                                borderLeft: `4px solid ${contentGroup === "publications"
                                    ? "#00a62b"
                                    : contentGroup === "upgrades"
                                      ? "#e6c300"
                                      : "#007bff"
                                  }`,
                                position: "relative"
                              }}
                            >
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: 6 }}>
                                <span style={{ fontSize: 13, fontWeight: "bold", color: "#444" }}>
                                  {pack.description}
                                </span>
                                {dateExpiresStr && (
                                  <span style={{ fontSize: 11, color: "#888" }}>
                                    Vence: {dateExpiresStr}
                                  </span>
                                )}
                              </div>
                              {pack.listing_details && pack.listing_details.map((detail, idx) => {
                                const label = getListingTypeLabel(detail.listing_type_id);
                                const isOut = detail.remaining_listings === 0;
                                return (
                                  <div key={idx} style={{ marginTop: 4, display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12 }}>
                                    <span style={{ color: "#666" }}>
                                      • Tipo: <strong>{label}</strong>
                                    </span>
                                    <span style={{ textAlign: "right" }}>
                                      {detail.used_listings} / {detail.available_listings} usados
                                      <span style={{
                                        marginLeft: 8,
                                        padding: "2px 6px",
                                        borderRadius: 4,
                                        fontSize: 10,
                                        fontWeight: "bold",
                                        backgroundColor: isOut ? "#ffebee" : "#e8f5e9",
                                        color: isOut ? "#c62828" : "#2e7d32"
                                      }}>
                                        {isOut ? "Sin cupos" : `${detail.remaining_listings} libres`}
                                      </span>
                                    </span>
                                  </div>
                                );
                              })}
                            </Box>
                          );
                        })}
                      </List>
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <div style={{ fontSize: 13, color: "#999", marginTop: 8, textAlign: "center", padding: "10px 0" }}>
                No se encontraron paquetes activos contratados en esta cuenta.
              </div>
            )}
          </Box>
        </Dialog>
      </Grid>
      <Snackbar
        open={copyNotification}
        autoHideDuration={4000}
        onClose={handleCloseCopyNotification}
        message="Enlace copiado"
      />
      <QualityTipsModal
        open={openQualityTips}
        onClose={handleCloseQualityTips}
        propiedad={selectedPropForQuality}
      />
    </Grid>
  );
};

export default TablaPropiedades;
